
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Vue, Options } from "vue-class-component";
import ShipmentTable, {
  ShipmentDataProps
} from "./components/shipment-table/index.vue";
import {
  BookingAggregateState,
  CpShipmentGroupMetadata,
  createDefaultBookingAggregateState,
  FraudStatus,
  ScanLogEntry,
  ShipmentIdTable,
  STT,
  SuccessBooking
} from "@/domain/entities/CreateBookingV3";
import ScanBookingShipment from "./components/scan-booking-shipment/index.vue";
import {
  createSubmittedTokenSnapshot,
  isWithinTokenLimit,
  MAX_SCAN_TOKENS
} from "./components/scan-booking-shipment/tokenizer";
import { CreateBookingV3Controller } from "@/app/ui/controllers/CreateBookingV3Controller";
import ShipmentStatusHeader from "./components/filter-table-booking-shipment/index.vue";
import ModalShipmentV3 from "./components/modal-shipment-v3/index.vue";
import EmptyList from "@/app/ui/components/status-handler/index.vue";
import { BookingController } from "@/app/ui/controllers/BookingController";
import {
  AddBookingCorporate,
  PrintDetailRequest
} from "@/data/payload/api/BookingRequest";
import {
  PrintDataEntitas,
  ShipmentId,
  ShipmentIdList,
  ShipmentIdSTT
} from "@/domain/entities/Booking";
import {
  AddShipmentBooking,
  AddShipmentBookingV2,
  CreateShipmentInstantBookingDirectlyPayload,
  ShipmentInstantBooking,
  ShipmentSttDetail
} from "@/data/payload/api/ShipmentBookingRequest";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { DistrictClientRequest } from "@/data/payload/api/LocationRequest";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { FlagsFeatureShipmentC1 } from "@/feature-flags/flags-shipment-c1";
import { flags } from "@/feature-flags";
import ModalSuccessBooking from "./components/modal-booking/modal-success.vue";
import { ThermalReceiptData } from "@/domain/entities/Printer";
import {
  downloadFilePrn,
  payloadOfThermalData
} from "@/app/infrastructures/misc/UtilsThermal";
import generateCommercialInvoiceV2 from "@/app/ui/modules/commercial-invoice-v2";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import ModalFailedShipment from "./components/modal-booking/modal-failed.vue";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import {
  FAILED_ERROR,
  SPECIAL_ERROR
} from "@/app/infrastructures/misc/Constants";
import JsBarcode from "jsbarcode";
import generatePDFV2 from "@/app/ui/modules/receipt-v2/document";
import generateThermalPDFV2 from "@/app/ui/modules/receipt-v2/thermal";
import { logoBlack } from "@/app/ui/modules/receipt-v2/constants/images";
import { flatten } from "lodash";
import generateThermalPDF from "../../bulk-print-resi/modules/bulk-label-resi-thermal";
import generatePDF from "../../bulk-print-resi/modules/bulk-label-resi-pdf";
import { isCustomerApps } from "../../../track-delivery/delivery-tab/modules";
import { createFocusTrap } from "focus-trap";
import { FlagsPermissionBookingV3 } from "../../../../../../feature-flags/flag-booking-v3";
import { LogProsesScan } from "@/domain/entities/BookingV4";
import ModalShipmentV4 from "../create-booking-v4/components/modal-shipment-v4/index.vue";
import ModalSuccessBookingV4 from "../create-booking-v4/components/modal-booking/modal-success.vue";
import ModalFailedBookingV4 from "../create-booking-v4/components/modal-booking/modal-failed.vue";
import { FlagsPermissionBookingV4 } from "@/feature-flags/flag-booking-v4";

/* eslint-disable @typescript-eslint/camelcase */

interface ReceiptPrintTarget {
  sttId: number;
  sttNo: string;
  accountType: string;
}

@Options({
  components: {
    ShipmentTable,
    ScanBookingShipment,
    ShipmentStatusHeader,
    ModalShipmentV3,
    EmptyList,
    ModalSuccessBooking,
    ModalFailedShipment,
    ModalShipmentV4,
    ModalSuccessBookingV4,
    ModalFailedBookingV4
  },
  watch: {
    isBookingShipment: {
      async handler(isOpen) {
        if (isOpen) {
          await this.$nextTick();
          const modal = document.getElementById("modal-shipment-v3-parent");
          if (!modal) return;
          this.focusTrap = createFocusTrap(modal.querySelector("div") as any, {
            escapeDeactivates: true,
            allowOutsideClick: true,
            returnFocusOnDeactivate: true,
            clickOutsideDeactivates: false,
            onDeactivate: () => {
              this.isBookingShipment = false;
              this.focusTrap = null;
            }
          });
          this.focusTrap.activate();
        } else {
          if (this.focusTrap) {
            this.focusTrap.deactivate();
            this.focusTrap = null;
          }
        }
      }
    }
  }
})
class CreateBookingShipment extends Vue {
[x: string]: any;
  shipmentId: string[] = [];
  shipmentIdData: ShipmentDataProps[] = [];
  lastNumber = 0;
  filter = {
    isSuccessBooking: false,
    isNotBooked: false,
    isFailedBooking: false,
    isAscending: false
  };
  listKGs: any = [
    {
      grossWeight: 1,
      dimension: {
        length: 3,
        width: 20,
        height: 10
      },
      volumeWeight: 0.1,
      convertVolumeWeight: "0,1"
    }
  ];
  isShowModalSuccessBooking = false;
  isShowModalFailedBooking = false;
  modalSuccessBookingData = new SuccessBooking();
  modalSuccessTotalPieces = 1;
  modalFailedBookingData = {
    error: "",
    balance: 0,
    price: 0
  };
  storageImages = new Array(this.maxPhoto).fill("");
  isAddAddress = false;
  onReloadBooking: any = null;
  focusTrap: any = null;
  aggregateState: BookingAggregateState = createDefaultBookingAggregateState();

  mounted() {
    this.autoScanShipment();
  }

  goBack() {
    this.$router.push("/booking-v2");
  }

  get flagPermissionShowErrorExist() {
    return FlagsPermissionBookingV3.exist_booked.isEnabled();
  }

  get isBookingMarketplaceV4() {
    return FlagsPermissionBookingV4.permission_booking_v4_create_markeplace.isEnabled();
  }
  get printAccountType(): string {
    const account = AccountController.accountData;
    return account.account_type === "partner"
      ? account.account_type_detail.type
      : account.account_type;
  }

  get maxPhoto() {
    return flags.flag_max_photo_for_weight_adjustment.getValue();
  }

  get bulkShipmentGroups(): ShipmentDataProps[] {
    const groups = new Map<string, ShipmentIdTable[]>();
    this.aggregateState.shipmentRows.forEach((row) => {
      const key = row.groupId || row.shipmentId;
      const group = groups.get(key) ?? [];
      if (!group.length) groups.set(key, group);
      group.push(row);
    });
    return Array.from(groups, ([shipmentId, data]) => ({ shipmentId, data }));
  }

  get allShipmentGroups(): ShipmentDataProps[] {
    return [...this.shipmentIdData, ...this.bulkShipmentGroups];
  }

  get printableShipmentGroups(): ShipmentDataProps[] {
    return this.allShipmentGroups.flatMap((group) =>
      group.data.reduce<ShipmentDataProps[]>((printGroups, item) => {
        if (!item.STT?.sttNo || !item.STT?.sttId) return printGroups;

        printGroups.push({
          shipmentId: `${group.shipmentId}-${item.id}`,
          data: [item]
        });
        return printGroups;
      }, [])
    );
  }

  mapReceiptPrintTargets(rows: ShipmentIdTable[]): ReceiptPrintTarget[] {
    return rows.reduce<ReceiptPrintTarget[]>((targets, row) => {
      const stt = row.STT;
      if (!stt?.sttId || !stt.sttNo) return targets;

      targets.push({
        sttId: stt.sttId,
        sttNo: stt.sttNo,
        accountType: this.printAccountType
      });
      return targets;
    }, []);
  }

  get receiptPrintTargets(): ReceiptPrintTarget[] {
    return this.printableShipmentGroups.flatMap((group) =>
      this.mapReceiptPrintTargets(group.data)
    );
  }

  findShipmentRow(id: number): ShipmentIdTable | undefined {
    return this.allShipmentGroups
      .flatMap((group) => group.data)
      .find((item) => item.id === id);
  }

  isSameShipmentRow(
    row: ShipmentIdTable,
    target: ShipmentIdTable | ShipmentId
  ): boolean {
    const targetId = (target as ShipmentIdTable).id;
    if (targetId && row.id === targetId) return true;
    return !!target.uniqueId && row.uniqueId === target.uniqueId;
  }

  get filteredShipmentIdData(): ShipmentDataProps[] {
    return [...this.allShipmentGroups]
      .sort(this.sortShipmentList)
      .map(this.filterShipmentList)
      .filter((shipment) => !!shipment.data.length);
  }

  get scanPanelEntries(): LogProsesScan[] {
    return this.aggregateState.log.map(
      (entry) =>
        new LogProsesScan({
          id: `${entry.shipmentNumber}-${entry.occurredAt}`,
          shipmentNumber: entry.shipmentNumber,
          reasonFailed:
            entry.reason === "duplicate"
              ? `Shipment ID ${entry.shipmentNumber} sudah ada di dalam daftar`
              : entry.reason === "not_found"
              ? "Shipment tidak ditemukan"
              : entry.reason,
          scannedAt: entry.occurredAt
        })
    );
  }

  async onScanShipment(
    shipmentIds: string[] = [],
    callBack: (error?: any) => void
  ) {
    const isLimitToken = !this.storeSubmittedTokenSnapshot(shipmentIds);
    if (isLimitToken) {
      this.shipmentId = shipmentIds;
      return;
    }
    await this.runScanTokenQueue();
    callBack();
  }

  storeSubmittedTokenSnapshot(shipmentIds: string[]): boolean {
    if (!isWithinTokenLimit(shipmentIds)) {
      playNotification("error");

      MainAppController.setSnackbarMessage(`
        <div class='flex flex-col text-black-lp-100'>
          <div class='text-base font-semibold'>Maksimal ${MAX_SCAN_TOKENS} ID per scan</div>
          <p class='text-sm'>Jumlah ID melebihi batas maksimum. Hanya ${MAX_SCAN_TOKENS} ID pertama yang berhasil ditambahkan.</p>
        </div>
      `);
      MainAppController.setSnackbarPositivity(false);
      MainAppController.setSnackbarTimeout(3000);
      MainAppController.setSnackbarBackgroundColor("#FEFAE8");
      MainAppController.setSnackbarIconLeft("info-red");
      MainAppController.setSnackbar(true);

      return false;
    }
    const snapshot = createSubmittedTokenSnapshot(shipmentIds);
    this.aggregateState.submittedTokenSnapshot = snapshot;
    return true;
  }

  get isScanQueueRunning(): boolean {
    return this.aggregateState.isBatchRunning;
  }

  onInstantBookingChange(isActive: boolean): void {
    this.aggregateState.bookingInstanConsent = isActive;
  }

  async runScanTokenQueue(): Promise<void> {
    const snapshot = this.aggregateState.submittedTokenSnapshot;
    if (!snapshot || this.aggregateState.isBatchRunning) {
      return;
    }

    this.aggregateState.isBatchRunning = true;
    MainAppController.showLoading();
    try {
      for (let i = 0; i < snapshot.tokens.length; i++) {
        const token = snapshot.tokens[i];
        await this.processScanToken(token);
      }
    } finally {
      MainAppController.closeLoading();
      this.aggregateState.isBatchRunning = false;
      this.aggregateState.submittedTokenSnapshot = null;
    }
  }

  async processScanToken(token: string): Promise<void> {
    if (this.aggregateState.skipSet.has(token)) {
      this.addScanLogEntry(token, "duplicate");
      playNotification("error");
      return;
    }

    const alreadyScanned = this.isTokenAlreadyScanned(token);

    if (alreadyScanned) {
      this.addScanLogEntry(token, "duplicate");
      playNotification("error");
      return;
    }

    const isInstant = this.aggregateState.bookingInstanConsent;

    try {
      if (token.startsWith("TKP")) {
        const result = await this.onScanPrefixTKP(token);
        if (isInstant) {
          await this.processInstantBookingTKP(token, result);
        } else {
          await this.validateAndMapTKP(token, result);
        }
      } else {
        const result = await this.onScanPrefixNonTKP(token);
        if (
          isInstant &&
          !this.isShipmentAPAS(token) &&
          !this.isCorporatePackage(token)
        ) {
          await this.processInstantBookingNonTKP(token, result);
        } else {
          await this.validateAndMapNonTKP(token, result);
        }
      }
      this.aggregateState.skipSet.add(token);
    } catch (error) {
      this.addScanLogEntry(token, parsingErrorResponse(error).message);
      playNotification("error");
    }
  }

  isTokenAlreadyScanned(token: string): boolean {
    const inLegacyData = this.shipmentIdData.some(
      (group) =>
        group.shipmentId === token ||
        group.data.some((item) => item.shipmentAlgoId === token)
    );
    const inBulkData = this.aggregateState.shipmentRows.some(
      (row) =>
        row.groupId === token ||
        row.shipmentId === token ||
        row.shipmentAlgoId === token
    );
    return inLegacyData || inBulkData;
  }

  async validateAndMapTKP(
    token: string,
    shipmentIdList: any
  ): Promise<ShipmentId[] | null> {
    const dataArray = this.extractShipmentDataArray(shipmentIdList);
    if (!dataArray?.length) {
      this.addScanLogEntry(token, "not_found");
      return null;
    }
    const isJumbopack =
      this.isIncludesJumbopack(dataArray).length && !this.isPartnerPcu;
    const newShipmentData = await this.mapShipmentDataTKP({
      data: dataArray
    } as ShipmentIdList);
    this.appendBulkShipmentRows(token, newShipmentData);
    if (isJumbopack) {
      playNotification("error");
      const displayId =
        dataArray[0].shipmentId ||
        dataArray[0].shipmentAlgoId ||
        dataArray[0].shipmentPacketId;
      this.addScanLogEntry(
        token,
        `Shipment ID "${displayId}" hanya bisa diproses oleh POS PCU karena pengiriman menggunakan product Jumbopack. Silahkan hubungi pengirim ${dataArray[0].shipmentSenderName}, ${dataArray[0].shipmentSenderPhoneOriginal} untuk melakukan pengembalian.`
      );
    }
    return dataArray;
  }

  async validateAndMapNonTKP(
    token: string,
    shipmentIdList: any
  ): Promise<ShipmentId[] | null> {
    const dataArray = this.extractShipmentDataArray(shipmentIdList);
    if (!dataArray?.length) {
      this.addScanLogEntry(token, "not_found");
      return null;
    }
    if (this.isCorporatePackage(dataArray[0]?.shipmentAlgoId || token)) {
      return this.validateAndMapCpShipment(token, dataArray);
    }
    const posCity = AccountController.accountData.account_type_detail.cityCode;
    const validationOriginDistrict =
      dataArray[0]?.shipmentOriginCity !== posCity ||
      !dataArray[0]?.shipmentOriginCity;
    const validationBukaSend = token.startsWith("B1") || token.startsWith("B2");
    if (token.startsWith("ACR") || token.startsWith("CCR")) {
      playNotification("error");
      this.addScanLogEntry(
        token,
        "Silahkan update STT pengiriman ke Custom Status RTS/RTSHQ melalui akun konsolidator/sub konsolidator untuk generate STT pengembalian"
      );
      return null;
    } else if (validationBukaSend && validationOriginDistrict) {
      playNotification("error");
      this.addScanLogEntry(
        token,
        "Kota asal shipment id harus sesuai dengan wilayah kota POS Anda."
      );
      return null;
    }
    const isJumbopack =
      this.isIncludesJumbopack(dataArray).length && !this.isPartnerPcu;
    const newData = dataArray.map((item: any) => ({
      ...this.mapSuccessScan(item)
    }));
    this.appendBulkShipmentRows(token, newData);
    if (isJumbopack) {
      playNotification("error");
      const displayId =
        dataArray[0].shipmentId ||
        dataArray[0].shipmentAlgoId ||
        dataArray[0].shipmentPacketId;
      this.addScanLogEntry(
        token,
        `Shipment ID "${displayId}" hanya bisa diproses oleh POS PCU karena pengiriman menggunakan product Jumbopack. Silahkan hubungi pengirim ${dataArray[0].shipmentSenderName}, ${dataArray[0].shipmentSenderPhoneOriginal} untuk melakukan pengembalian.`
      );
    }
    return dataArray;
  }

  extractShipmentDataArray(result: any): ShipmentId[] | null {
    if (!result) return null;

    if (Array.isArray(result)) {
      if (result[0]?.data && Array.isArray(result[0].data)) {
        return result.flatMap((item: any) => item?.data || []) as ShipmentId[];
      }
      return result as ShipmentId[];
    }

    if (result.data && Array.isArray(result.data)) {
      if (result.data[0]?.data && Array.isArray(result.data[0].data)) {
        return result.data.flatMap(
          (item: any) => item?.data || []
        ) as ShipmentId[];
      }
      return result.data as ShipmentId[];
    }

    if (result.data?.data && Array.isArray(result.data.data)) {
      if (
        result.data.data[0]?.data &&
        Array.isArray(result.data.data[0].data)
      ) {
        return result.data.data.flatMap(
          (item: any) => item?.data || []
        ) as ShipmentId[];
      }
      return result.data.data as ShipmentId[];
    }

    return null;
  }

  appendBulkShipmentRows(
    token: string,
    shipmentData: any[],
    isInstantBooking = false
  ): void {
    if (!shipmentData.length) {
      return;
    }
    if (token.startsWith("G")) {
      this.removeReplacedGPrefixRows(shipmentData);
    }
    shipmentData.forEach((item) => {
      const bookingStatus = item.STT?.sttNo
        ? "berhasil_dibooking"
        : "belum_dibooking";
      this.lastNumber += 1;
      this.aggregateState.shipmentRows.push(
        new ShipmentIdTable({
          ...item,
          groupId: token,
          id: new Date().getTime() + this.lastNumber,
          no: this.lastNumber,
          isLoading: false,
          isDeleted: false,
          isInstantBooking,
          error: null,
          bookingStatus
        })
      );
    });
  }

  removeReplacedGPrefixRows(shipmentData: any[]): void {
    const algoIds = new Set(
      shipmentData.map((item: any) => item.shipmentAlgoId).filter(Boolean)
    );
    if (!algoIds.size) return;
    this.shipmentIdData = this.shipmentIdData.filter(
      (group) => !algoIds.has(group.shipmentId)
    );
    this.aggregateState.shipmentRows = this.aggregateState.shipmentRows.filter(
      (row) => !algoIds.has(row.shipmentId)
    );
  }

  updateBulkRowInstantBooking(rowId: number, isInstantBooking: boolean): void {
    const index = this.aggregateState.shipmentRows.findIndex(
      (r) => r.id === rowId
    );
    if (index === -1) return;
    const row = this.aggregateState.shipmentRows[index];
    this.aggregateState.shipmentRows.splice(index, 1, {
      ...row,
      isInstantBooking
    });
  }

  updateBulkRowWithSTT(rowId: number, stt: ShipmentIdSTT): void {
    const index = this.aggregateState.shipmentRows.findIndex(
      (r) => r.id === rowId
    );
    if (index === -1) return;
    const row = this.aggregateState.shipmentRows[index];
    this.aggregateState.shipmentRows.splice(index, 1, {
      ...row,
      STT: stt,
      isInstantBooking: true,
      bookingStatus: "berhasil_dibooking"
    });
  }

  async processInstantBookingTKP(
    token: string,
    shipmentIdList: any
  ): Promise<void> {
    const dataArray = this.extractShipmentDataArray(shipmentIdList);
    if (!dataArray?.length) {
      this.addScanLogEntry(token, "not_found");
      return;
    }
    const newShipmentData = await this.mapShipmentDataTKP({
      data: dataArray
    } as ShipmentIdList);
    this.appendBulkShipmentRows(token, newShipmentData, true);

    const batchRows = this.aggregateState.shipmentRows.filter(
      (row) => row.groupId === token
    );

    for (let i = 0; i < newShipmentData.length; i++) {
      const shipment = newShipmentData[i];
      const row = batchRows[i];
      if (!row) continue;

      if (this.isShipmentBookingInvalid(shipment, true)) {
        this.updateBulkRowInstantBooking(row.id, false);
        continue;
      }

      const res = await this.bookingShipmentCorporate(
        this.mapPayloadBookingCorporate(shipment)
      );
      if (!res) continue;

      const stt = new ShipmentIdSTT({
        shipmentAlgoId: token,
        sttId: res.sttId,
        sttNo: res.sttNumber,
        sttProductType: shipment.shipmentProduct,
        sttTotalAmount: res.totalAfterDiscount,
        sttPieces: this.mappingSttPieces(shipment),
        sttChargeableWeight: res.chargeableWeight
      });
      this.updateBulkRowWithSTT(row.id, stt);
    }
  }

  async processInstantBookingNonTKP(
    token: string,
    shipmentIdList: any
  ): Promise<void> {
    const dataArray = this.extractShipmentDataArray(shipmentIdList);
    if (!dataArray?.length) {
      this.addScanLogEntry(token, "not_found");
      return;
    }
    const newData = dataArray.map((item: any) => ({
      ...this.mapSuccessScan(item)
    }));
    this.appendBulkShipmentRows(token, newData, true);

    const batchRows = this.aggregateState.shipmentRows.filter(
      (row) => row.groupId === token
    );

    for (let i = 0; i < dataArray.length; i++) {
      const shipment = dataArray[i];
      const row = batchRows[i];
      if (!row) continue;

      if (this.isShipmentBookingInvalid(shipment, false)) {
        this.updateBulkRowInstantBooking(row.id, false);
        continue;
      }

      const stt = this.instantBookingDirectFlowEnabled
        ? await this.createShipmentInstantBookingDirectly(token, shipment)
        : await this.addInstantBooking(token, shipment);

      if (!stt) continue;

      this.updateBulkRowWithSTT(row.id, stt);
    }
  }

  addScanLogEntry(shipmentNumber: string, reason: string): void {
    this.aggregateState.log.unshift(
      new ScanLogEntry({
        shipmentNumber,
        reason,
        occurredAt: new Date().toISOString()
      })
    );
  }

  get clientIdForCourierRecommendation() {
    return FlagsMedusa.client_id_courrier_recommendation_config.getValue();
  }

  async onScanPrefixTKP(shipmentId: string) {
    return CreateBookingV3Controller.getShipmentDetailFromMiddleware({
      ticketCode: shipmentId
    });
  }

  async onScanPrefixNonTKP(shipmentId: string) {
    return CreateBookingV3Controller.getShipmentIdList({
      id: shipmentId,
      limit: 100,
      page: 1
    });
  }

  onBookingShipment(shipmentId = "", id = 0, version = "") {
    this.bookingState = version;
    if (version !== "v4") {
      this.isSequentialBookingActive = false;
      this.skippedBookingShipmentIds = new Set();
    }

    const shipmentTable = this.findShipmentRow(id);
    if (!shipmentTable) return;
    const isTKP = shipmentId.startsWith("TKP");

    if (this.isShipmentBookingInvalid(shipmentTable, isTKP)) {
      this.onEditShipment(shipmentId, id, version);
      return;
    }
    if (isTKP) {
      this.addBookingCorporate(
        shipmentTable,
        this.mapPayloadBookingCorporate(shipmentTable)
      );
    } else {
      this.addShipmentBooking(
        shipmentTable,
        this.mappingPayloadBookingShipment(shipmentTable)
      );
    }
  }

  async onBookingFromModal(
    payload: AddShipmentBookingV2,
    shipmentTable: ShipmentIdTable,
    type = "",
    isAddAddress: boolean
  ) {
    this.isCrossCountryCod = payload.isCrossCountryCod;
    this.prefixCurrency = payload.prefixCurrency;

    switch (type) {
      case "book-print-later":
        await this.onCreateBookingFromModal(
          payload,
          shipmentTable,
          isAddAddress
        );
        break;
      case "book-print-thermal":
        await this.bookPrintThermal(payload, shipmentTable, isAddAddress);
        break;
      case "book-print-thermal-pdf":
        await this.bookPrintDoc(0, true, payload, shipmentTable, isAddAddress);
        break;
      case "book-print-pdf":
        await this.bookPrintDoc(1, false, payload, shipmentTable, isAddAddress);
        break;
      default:
        await this.onCreateBookingFromModal(
          payload,
          shipmentTable,
          isAddAddress
        );
        break;
    }
  }

  onCreateBookingFromModal(
    payload: AddShipmentBookingV2,
    shipmentTable: ShipmentIdTable,
    isAddAddress: boolean
  ) {
    if (shipmentTable.shipmentAlgoId.startsWith("TKP")) {
      return this.addBookingCorporate(shipmentTable, payload, true);
    } else {
      return this.addShipmentBooking(
        shipmentTable,
        payload,
        true,
        isAddAddress
      );
    }
  }

  async bookPrintThermal(
    payload: AddShipmentBookingV2,
    shipmentTable: ShipmentIdTable,
    isAddAddress: boolean
  ) {
    const book = await this.onCreateBookingFromModal(
      payload,
      shipmentTable,
      isAddAddress
    );
    if (!book) {
      return;
    }
    this.printThermal(book.data.stt[0].stt_id, book.data.stt[0].stt_no);
  }

  async bookPrintDoc(
    type: number,
    autoPrint = false,
    payload: AddShipmentBookingV2,
    shipmentTable: ShipmentIdTable,
    isAddAddress: boolean
  ) {
    const book = await this.onCreateBookingFromModal(
      payload,
      shipmentTable,
      isAddAddress
    );
    if (!book) {
      return;
    }
    await this.printDoc(
      book.data.stt[0].stt_id,
      book.data.stt[0].stt_no,
      type,
      autoPrint
    );
  }

  async printDoc(sttId: any, sttNo: any, type: number, autoPrint: boolean) {
    const print = await this.generatePrintData(sttId, sttNo);
    if (print) {
      await this.loadToPdf(type, true, autoPrint);
    }
  }

  onEditShipment(shipmentId = "", id = 0, version = "") {
    if (version !== "v4") {
      this.isSequentialBookingActive = false;
      this.skippedBookingShipmentIds = new Set();
    }

    const shipmentTable = this.allShipmentGroups
      .flatMap((group) => group.data)
      .filter((item) => !item.STT?.sttNo);

    const index = shipmentTable.findIndex((item) => item.id === id);
    if (index === -1) return;

    const [selectedItem] = shipmentTable.splice(index, 1);
    shipmentTable.unshift(selectedItem);

    this.shipmentList = shipmentTable;
    this.selectedIndex = 0;
    this.isAddAddress = false;
    this.bookingState = version;

    this.isCrossCountryCod = false;
    this.prefixCurrency = "";
    this.isBookingShipment = true;
  }

  onDeleteShipment(shipmentId = "", id = 0) {
    this.shipmentIdData = this.shipmentIdData
      .map((group) => ({
        ...group,
        data: group.data.filter((item) => item.id !== id)
      }))
      .filter((group) => group.data.length > 0);

    const deletedRow = this.aggregateState.shipmentRows.find(
      (item) => item.id === id
    );
    this.aggregateState.shipmentRows = this.aggregateState.shipmentRows.filter(
      (item) => item.id !== id
    );
    if (
      deletedRow?.groupId &&
      !this.aggregateState.shipmentRows.some(
        (item) => item.groupId === deletedRow.groupId
      )
    ) {
      this.aggregateState.skipSet.delete(deletedRow.groupId);
      delete this.aggregateState.cpGroupMetadata[deletedRow.groupId];
    }
  }

  onAddAddress(shipmentId = "") {
    const shipmentToAdd = this.shipmentIdData.find(
      (item) => item.shipmentId === shipmentId
    );
    if (shipmentToAdd) {
      shipmentToAdd.data.unshift(
        new ShipmentIdTable({
          id: new Date().getTime() + shipmentToAdd.data.length,
          uniqueId: new Date().getTime() + Math.random(),
          shipmentId: shipmentId,
          shipmentAlgoId: shipmentId
        })
      );
      return;
    }

    const sourceIndex = this.aggregateState.shipmentRows.findIndex(
      (item) => item.groupId === shipmentId || item.shipmentId === shipmentId
    );
    if (sourceIndex === -1) return;

    const sourceRow = this.aggregateState.shipmentRows[sourceIndex];
    this.aggregateState.shipmentRows.splice(
      sourceIndex,
      0,
      new ShipmentIdTable({
        id: new Date().getTime() + sourceRow.id,
        uniqueId: new Date().getTime() + Math.random(),
        shipmentId,
        shipmentAlgoId: shipmentId,
        groupId: sourceRow.groupId || shipmentId
      })
    );
  }

  async onPrintSttShipment(
    sttId = 0,
    sttNo = "",
    type: "thermal-resi" | "thermal-pdf" | "print-basic"
  ) {
    if (!sttId) return;
    switch (type) {
      case "thermal-resi":
        this.printThermal(sttId, sttNo);
        break;
      case "thermal-pdf":
        await this.printDoc(sttId, sttNo, 0, true);
        break;
      case "print-basic":
        await this.printDoc(sttId, sttNo, 1, false);
        break;
    }
  }

  async onPrintAll(type: "thermal-resi" | "thermal-pdf" | "print-basic") {
    const refs: any = this.$refs;
    const shipmentGroups = this.printableShipmentGroups;
    refs["shipment-status-header"]?.togglePanel(null);
    if (!shipmentGroups.length) return;
    this.resetResiListData();
    await this.generateResiListDataBatch(shipmentGroups);
    switch (type) {
      case "thermal-resi":
        this.printThermalListStt();
        break;
      default:
        await this.printDocListStt(type);
        break;
    }
  }

  // utils
  sortShipmentList(a: ShipmentDataProps, b: ShipmentDataProps) {
    if (this.filter.isAscending) return a.data[0].id - b.data[0].id;
    return b.data[0].id - a.data[0].id;
  }

  filterShipmentList(shipment: ShipmentDataProps, _index = 0) {
    if (this.filter.isFailedBooking) {
      return {
        ...shipment,
        data: shipment.data.filter((data) => !!data.error)
      };
    }

    if (this.filter.isNotBooked) {
      return {
        ...shipment,
        data: shipment.data.filter((data) => !data.STT?.sttNo && !data.error)
      };
    }

    if (this.filter.isSuccessBooking) {
      return {
        ...shipment,
        data: shipment.data.filter((data) => !!data.STT?.sttNo)
      };
    }

    return shipment;
  }

  isBookingShipment = false;
  bookingState = "";
  selectedIndex = 0;
  shipmentList: ShipmentIdTable[] = [];
  isSequentialBookingActive = false;
  skippedBookingShipmentIds: Set<string> = new Set();

  get dataProfile() {
    return AccountController.accountData;
  }

  get originDistrict() {
    const detail = LocationController.districtDetail;
    return {
      id: detail.id,
      name: `${detail.name}, ${detail.cityName}`,
      code: `${detail.code}`,
      cityCode: `${detail.cityCode}`,
      ursaCode: detail.ursaCode,
      cityId: detail.cityId,
      cityName: detail.cityName
    };
  }

  mapPayloadBookingCorporate(shipment: ShipmentId | ShipmentIdTable) {
    return new AddShipmentBookingV2({
      sttClient: Number(shipment.shipmentSttClientId),
      stt: new ShipmentSttDetail({
        sttNo: "",
        sttShipmentId: shipment.shipmentAlgoId,
        sttNoRefExternal: this.mapShipmentNoRefExt(shipment),
        sttTaxNumber: "",
        sttGoodsEstimatePrice: shipment.shipmentGoodsPriceEstimation,
        sttGoodsStatus: shipment.shipmentGoodsStatus,
        sttOriginCityId: this.originDistrict.cityCode,
        sttOriginDistrictId: this.originDistrict.code,
        sttDestinationCityId: shipment.shipmentDestinationCity?.code,
        sttDestinationDistrictId: shipment.shipmentDestinationDistrict?.code,
        sttSenderName: shipment.shipmentSenderName,
        sttSenderPhone: shipment.senderPhoneInstantBooking,
        sttSenderAddress: shipment.shipmentSenderAddress,
        sttRecipientName: shipment.shipmentRecipientName,
        sttRecipientAddress: shipment.shipmentRecipientAddress,
        sttRecipientAddressType: "home",
        sttRecipientPhone: shipment.recipientPhoneInstantBooking,
        sttInsuranceType: shipment.shipmentInsurance,
        sttProductType: shipment.shipmentProduct,
        sttCommodityCode: "GEN",
        sttClientSttId: Number(shipment.shipmentSttClientId),
        sttVendorSttId: 0,
        sttIsCod: shipment.shipmentIsCod,
        sttIsWoodpacking: shipment.shipmentIsWoodpacking,
        sttPieces: this.mappingSttPieces(shipment),
        sttPiecePerPack: 0,
        sttNextCommodity: "",
        sttCodAmount: shipment.codAmount,
        postalCodeDestination: shipment.postalCodeDestination
      }),
      otherShipperTicketCode: shipment.dataRaw?.other_shipper_ticket_code
    });
  }

  async bookingShipmentCorporate(payload: AddShipmentBookingV2) {
    try {
      const res = await BookingController.addBookingCorporateV2(payload);
      return res;
    } catch (err) {
      const shipmentTable = this.allShipmentGroups
        .flatMap((group) => group.data)
        .find(
          (shipmentId) =>
            shipmentId.shipmentAlgoId === payload.stt.sttShipmentId
        );
      if (shipmentTable) {
        this.updateShipmentTableErrorData(err, shipmentTable);
      }
      throw err;
    }
  }

  async addInstantBooking(id: string, shipment: ShipmentId) {
    try {
      const res = await ShipmentBookingController.addInstantBooking(
        new ShipmentInstantBooking({
          shipmentPackageId: shipment.shipmentPacketId,
          stt: {
            sttNo: "",
            sttShipmentId: shipment.shipmentAlgoId,
            sttTaxNumber: "",
            sttGoodsEstimatePrice: shipment.shipmentGoodsPriceEstimation,
            sttGoodsStatus: shipment.shipmentGoodsStatus,
            sttNoRefExternal: shipment.shipmentBookingId.startsWith("TSLP")
              ? shipment.shipmentBookingId
              : "",
            sttOriginCityId: this.originDistrict.cityCode,
            sttDestinationCityId: shipment.shipmentDestinationCity?.code,
            sttOriginDistrictId: this.originDistrict.code,
            sttDestinationDistrictId:
              shipment.shipmentDestinationDistrict?.code,
            sttSenderName: shipment.shipmentSenderName,
            sttSenderPhone: shipment.senderPhoneInstantBooking,
            sttSenderAddress: shipment.shipmentSenderAddress,
            sttRecipientName: shipment.shipmentRecipientName,
            sttRecipientPhone: shipment.recipientPhoneInstantBooking,
            sttRecipientAddress: shipment.shipmentRecipientAddress,
            sttProductType: shipment.shipmentProduct,
            sttCommodityCode: shipment.shipmentCommodityCode || "GEN",
            sttInsuranceType: shipment.shipmentInsurance,
            sttIsDo: shipment.isDO,
            sttIsCod: shipment.shipmentIsCod,
            sttIsDfod: shipment.shipmentIsDfod,
            sttCodFee: shipment.codFee,
            sttCodAmount: shipment.codAmount,
            sttPieces: this.mappingSttPieces(shipment),
            postalCodeDestination: shipment.postalCodeDestination,
            addressReceiverType: "home",
            sttWoodpacking: shipment.shipmentIsWoodpacking,
            sttAttachFiles: shipment.STT?.sttAttachFiles,
            sttRecipientEmail: shipment.STT?.sttRecipientEmail || "",
            sttKtpImage: shipment.STT?.sttKtpImage || "",
            sttTaxImage: shipment.STT?.sttTaxImage || "",
            sttInterTaxNumber: shipment.STT?.sttInterTaxNumber || "",
            sttIdentityNumber: shipment.STT?.sttIdentityNumber || "",
            sttCipl: shipment.STT?.sttcipl
          },
          districtOrigin: {
            id: this.originDistrict.id,
            code: this.originDistrict.code,
            name: this.originDistrict.name,
            ursaCode: this.originDistrict.ursaCode,
            city: {
              id: this.originDistrict.cityId,
              code: this.originDistrict.cityCode,
              name: this.originDistrict.cityName
            }
          },
          districtDestination: {
            id: shipment.shipmentDestinationDistrict.id,
            code: shipment.shipmentDestinationDistrict.code,
            name: shipment.shipmentDestinationDistrict.name,
            ursaCode: shipment.shipmentDestinationDistrict.ursa_code,
            isCod: shipment.shipmentDestinationDistrict.is_cod,
            status: shipment.shipmentDestinationDistrict.status,
            type: shipment.shipmentDestinationDistrict.type,
            city: {
              id: shipment.shipmentDestinationCity.id,
              code: shipment.shipmentDestinationCity.code,
              name: shipment.shipmentDestinationCity.name
            }
          },
          commodity: {
            commodityId: shipment.shipmentCommodityId,
            commodityCode: shipment.shipmentCommodityCode,
            commodityName: shipment.shipmentCommodityName,
            commodityDocumentSurcharge:
              shipment.shipmentCommodityDocumentSurcharge,
            hsCode: shipment.shipmentCommodityHsCode
          },
          partner: {
            id: this.dataProfile.account_type_detail?.id,
            name: this.dataProfile.account_type_detail?.company_name,
            code: this.dataProfile.account_type_detail?.code,
            partnerExternalCode: this.dataProfile.account_type_detail
              ?.partnerExternalCode,
            partnerLocation: {
              id: this.dataProfile.account_type_detail?.partnerLocation?.id,
              districtCode: this.dataProfile.account_type_detail
                ?.partnerLocation?.district_code
            },
            partnerLocationList: []
          },
          isNewForm: true
        })
      );
      return new ShipmentIdSTT({
        shipmentAlgoId: id,
        sttId: res.sttId,
        sttNo: res.sttNumber,
        sttProductType: shipment.shipmentProduct,
        sttTotalAmount: res.totalAfterDiscount,
        sttPieces: this.mappingSttPieces(shipment),
        sttChargeableWeight: res.chargeableWeight
      });
    } catch (err) {
      const shipmentTable =
        this.shipmentIdData
          .flatMap((group) => group.data)
          .find(
            (shipmentId) =>
              shipmentId.shipmentAlgoId === shipment.shipmentAlgoId
          ) ||
        this.aggregateState.shipmentRows.find(
          (row) => row.shipmentAlgoId === shipment.shipmentAlgoId
        );
      if (shipmentTable) {
        this.updateShipmentTableErrorData(err, shipmentTable);
      }
      return null;
    }
  }

  async createShipmentInstantBookingDirectly(id: string, shipment: ShipmentId) {
    try {
      const res = await ShipmentBookingController.createShipmentInstantBookingDirectly(
        new CreateShipmentInstantBookingDirectlyPayload({
          shipmentId: id,
          bookingFormVersion: this.isBookingMarketplaceV4 ? "v4" : ""
        })
      );
      return new ShipmentIdSTT({
        shipmentAlgoId: id,
        sttId: res.sttId,
        sttNo: res.sttNumber,
        sttProductType: shipment.shipmentProduct,
        sttTotalAmount: res.totalAfterDiscount,
        sttPieces: this.mappingSttPieces(shipment),
        sttChargeableWeight: res.chargeableWeight
      });
    } catch (err) {
      const shipmentTable =
        this.shipmentIdData
          .flatMap((group) => group.data)
          .find(
            (shipmentId) =>
              shipmentId.shipmentAlgoId === shipment.shipmentAlgoId
          ) ||
        this.aggregateState.shipmentRows.find(
          (row) => row.shipmentAlgoId === shipment.shipmentAlgoId
        );
      if (shipmentTable) {
        this.updateShipmentTableErrorData(err, shipmentTable);
      }
      return null;
    }
  }

  mappingSttPieces(shipment: any) {
    return shipment.shipmentGoodDetail.length
      ? shipment.shipmentGoodDetail.map((pieces: any) => ({
          stt_piece_length: pieces.shipment_goods_length,
          stt_piece_width: pieces.shipment_goods_width,
          stt_piece_height: pieces.shipment_goods_height,
          stt_piece_gross_weight: pieces.shipment_goods_weight
        }))
      : [];
  }

  isIncludesJumbopack(res: ShipmentId[]) {
    return res.filter(
      (key: any) =>
        key.shipmentProduct.toLowerCase() === "jumbopack" ||
        key.shipmentProduct.toLowerCase() === "jumbopackh2h"
    );
  }

  isShipmentBookingInvalid(
    shipment: ShipmentIdTable | ShipmentId,
    isTKP: boolean
  ): boolean {
    const isJumbopack =
      (shipment.shipmentProduct?.toLowerCase() === "jumbopack" ||
        shipment.shipmentProduct?.toLowerCase() === "jumbopackh2h") &&
      !this.isPartnerPcu;
    return (
      this.checkBookingData(shipment, isTKP) ||
      this.checkCommodity(shipment) ||
      isJumbopack
    );
  }

  get isPartnerPcu() {
    return this.dataProfile.isPartnerPcu;
  }

  mapSuccessScan(item: ShipmentId) {
    return {
      ...item,
      shipmentSenderPhone: item.shipmentSenderPhone.replace(/\+/g, ""),
      shipmentRecipientPhone: item.shipmentRecipientPhone.replace(/\+/g, ""),
      shipmentProductTemp: item.shipmentProduct,
      shipmentGoodDetail: item.shipmentGoodDetail.map((pieces: any) => ({
        ...pieces,
        shipment_goods_length: pieces.shipment_goods_length || 10,
        shipment_goods_width: pieces.shipment_goods_width || 10,
        shipment_goods_height: pieces.shipment_goods_height || 10
      }))
    };
  }

  async mapShipmentDataTKP(shipmentIdList: ShipmentIdList) {
    const newShipmentData = [];
    for (const el of shipmentIdList.data) {
      try {
        MainAppController.showLoading();
        const district = await LocationController.getDistrictClient({
          id: el.shipmentDestinationCityKR,
          args: new DistrictClientRequest({
            clientId: this.clientIdForCourierRecommendation
          })
        });
        newShipmentData.push(
          new ShipmentId({
            ...el,
            shipmentDestinationCity: {
              code: district.cityCode
            },
            shipmentDestinationDistrict: {
              code: district.code
            },
            shipmentSttClientId: this.clientIdForCourierRecommendation,
            shipmentSenderPhone: el.shipmentSenderPhone.replace(/\+/g, ""),
            shipmentRecipientPhone: el.shipmentRecipientPhone.replace(/\+/g, "")
          })
        );
      } catch (error) {
        newShipmentData.push(
          new ShipmentId({
            ...el,
            shipmentSttClientId: this.clientIdForCourierRecommendation
          })
        );
      } finally {
        MainAppController.closeLoading();
      }
    }
    return newShipmentData;
  }

  checkEligible(shipment: ShipmentId) {
    const sender =
      !shipment.shipmentSenderName ||
      !shipment.shipmentSenderAddress ||
      !shipment.shipmentSenderPhone;
    const receiverData =
      !shipment.shipmentRecipientName ||
      !shipment.shipmentRecipientAddress ||
      !shipment.shipmentRecipientPhone;
    const destinationDistrictData =
      shipment.shipmentDestinationDistrict &&
      shipment.shipmentDestinationDistrict.id !== 0;
    const detailProduct = !shipment.shipmentProduct;
    return sender || receiverData || !destinationDistrictData || detailProduct;
  }

  checkShipmentGoodDetail(shipment: ShipmentId, isTKP: boolean) {
    const shipmentGoodDetail =
      shipment.shipmentGoodDetail.length > 0 && isTKP
        ? this.checkPieceDataKr(shipment.shipmentGoodDetail)
        : this.checkPieceData(shipment.shipmentGoodDetail);
    return !shipmentGoodDetail;
  }

  checkPieceData(data: any) {
    const errorPieces: Array<any> = [];
    for (const el of data) {
      if (
        el.shipment_goods_weight !== 0 &&
        el.shipment_goods_length !== 0 &&
        el.shipment_goods_width !== 0 &&
        el.shipment_goods_height !== 0
      ) {
        errorPieces.push(true);
      } else {
        errorPieces.push(false);
      }
    }
    const checkPieces = errorPieces.every((item: any) => item);
    return !!checkPieces;
  }

  checkPieceDataKr(data: any) {
    const errorPieces: Array<any> = [];
    for (const el of data) {
      if (el.shipment_goods_weight !== 0) {
        errorPieces.push(true);
      } else {
        errorPieces.push(false);
      }
    }
    const checkPieces = errorPieces.every((item: any) => item);
    return !!checkPieces;
  }

  isShipmentAPAS(shipmentId: string) {
    return shipmentId.slice(0, 2) === "AP" || shipmentId.slice(0, 2) === "AS";
  }

  isCorporatePackage(shipmentAlgoId: string): boolean {
    return shipmentAlgoId.startsWith("CP");
  }

  async validateAndMapCpShipment(
    token: string,
    dataArray: ShipmentId[]
  ): Promise<ShipmentId[] | null> {
    const canonicalId = dataArray[0]?.shipmentAlgoId || token;
    const isDuplicateGroup = this.aggregateState.shipmentRows.some(
      (row) => row.groupId === canonicalId
    );
    if (isDuplicateGroup) {
      this.addScanLogEntry(token, "duplicate");
      playNotification("error");
      return null;
    }

    const first = dataArray[0];
    const actualTotalPieces = Number(first?.shipmentActualTotalPieces);
    const bookedTotalPieces = Number(first?.shipmentBookedTotalPieces);
    const remainingPieces = Number(first?.shipmentRemainingPieces);
    const latestStatus = first?.shipmentLatestStatus || "";
    const hasValidBalance =
      Number.isFinite(actualTotalPieces) &&
      Number.isFinite(bookedTotalPieces) &&
      Number.isFinite(remainingPieces) &&
      bookedTotalPieces + remainingPieces === actualTotalPieces;
    const isEligible =
      !!canonicalId &&
      !!first?.shipmentClientIdBranch &&
      !!first?.shipmentClientRef &&
      latestStatus === "CRRDON" &&
      remainingPieces > 0 &&
      hasValidBalance;

    if (!isEligible) {
      playNotification("error");
      this.addScanLogEntry(token, "Shipment CP tidak eligible untuk dibooking");
      return null;
    }

    this.aggregateState.cpGroupMetadata[
      canonicalId
    ] = new CpShipmentGroupMetadata({
      shipmentAlgoId: canonicalId,
      clientIdBranch: first.shipmentClientIdBranch,
      clientRef: first.shipmentClientRef,
      latestStatus,
      actualTotalPieces,
      bookedTotalPieces,
      remainingPieces
    });

    const bookedRows = dataArray
      .filter((item) => !!item.STT)
      .map((item) => ({
        ...this.mapSuccessScan(item),
        shipmentAlgoId: canonicalId
      }));
    // Prefer an item that isn't already booked as the template for the new
    // unbooked row, so booked-item-specific fields (e.g. recipient already
    // tied to that STT) don't leak into the fresh row. Group-level fields
    // (client/eligibility/balance) are shared across every `data[]` item
    // regardless of which one is used here.
    const unbookedTemplate = dataArray.find((item) => !item.STT) || first;
    const unbookedRow = {
      ...this.mapSuccessScan(unbookedTemplate),
      STT: null,
      shipmentAlgoId: canonicalId
    };
    this.appendBulkShipmentRows(canonicalId, [...bookedRows, unbookedRow]);

    return dataArray;
  }

  enabledCommodityT1B1B2(shipmentIdTable: ShipmentIdTable | ShipmentId) {
    const prefix = shipmentIdTable.shipmentAlgoId;
    return (
      prefix.startsWith("T1") ||
      prefix.startsWith("B1") ||
      prefix.startsWith("B2")
    );
  }

  shipmentC1Cod(shipmentIdTable: ShipmentIdTable | ShipmentId) {
    return (
      shipmentIdTable.shipmentAlgoId.startsWith(
        FlagsFeatureShipmentC1.feature_shipment_c1.getValue()
      ) && shipmentIdTable.shipmentIsCod
    );
  }

  get convertedArr() {
    return this.listKGs.map((key: any) => ({
      stt_piece_length: key.dimension.length,
      stt_piece_width: key.dimension.width,
      stt_piece_height: key.dimension.height,
      stt_piece_gross_weight: Number(
        key.grossWeight.toString().replace(",", ".")
      ),
      stt_piece_volume_weight: key.volumeWeight
    }));
  }

  get manualBooking(): any {
    return BookingController.manualBooking;
  }

  isCourierRecommendation(shipment: ShipmentIdTable | ShipmentId) {
    return !!shipment.dataRaw?.ticket_code;
  }

  mapShipmentNoRefExt(shipment: ShipmentIdTable | ShipmentId) {
    return this.isCourierRecommendation(shipment)
      ? shipment.dataRaw?.ticket_code
      : shipment.shipmentBookingId.startsWith("TSLP")
      ? shipment.shipmentBookingId
      : shipment.STT?.sttNoRefExternal || "";
  }

  payloadCommodityCode(shipmentIdTable: ShipmentIdTable | ShipmentId) {
    const commodityCode: any = shipmentIdTable.shipmentCommodityName;
    let payload;
    if (typeof commodityCode === "object") {
      payload = commodityCode.code;
    } else {
      payload = shipmentIdTable.shipmentCommodityCode;
    }
    return payload;
  }

  mappingPayloadBookingShipment(shipmentTable: ShipmentIdTable | ShipmentId) {
    return new AddShipmentBookingV2({
      sttClient: Number(shipmentTable.shipmentSttClientId),
      stt: new ShipmentSttDetail({
        sttNo: !this.manualBooking.sttManual.id
          ? ""
          : this.manualBooking.sttManual.id,
        sttShipmentId: shipmentTable.shipmentAlgoId,
        sttNoRefExternal: this.mapShipmentNoRefExt(shipmentTable),
        sttTaxNumber: shipmentTable.shipmentNpwpNumber,
        sttGoodsEstimatePrice: Number(
          shipmentTable.shipmentGoodsPriceEstimation
            .toString()
            .replace(/[.]/g, "")
        ),
        sttGoodsStatus: shipmentTable.shipmentGoodsStatus,
        sttOriginCityId: this.originDistrict.cityCode,
        sttOriginDistrictId: this.originDistrict.code,
        sttDestinationCityId: shipmentTable.shipmentDestinationCity?.code,
        sttDestinationDistrictId:
          shipmentTable.shipmentDestinationDistrict?.code,
        sttSenderName: shipmentTable.shipmentSenderName,
        sttSenderPhone: `${shipmentTable.shipmentSenderPhoneCode.substring(1)}${
          shipmentTable.shipmentSenderPhone
        }`,
        sttSenderAddress: shipmentTable.shipmentSenderAddress,
        sttRecipientName: shipmentTable.shipmentRecipientName,
        sttRecipientAddress: shipmentTable.shipmentRecipientAddress,
        sttRecipientAddressType: shipmentTable.sttRecipientAddressType,
        sttRecipientPhone: `${shipmentTable.shipmentRecipientPhoneCode.substring(
          1
        )}${shipmentTable.shipmentRecipientPhone}`,
        sttInsuranceType: shipmentTable.shipmentInsurance,
        sttProductType: shipmentTable.shipmentProduct,
        sttCommodityCode: this.payloadCommodityCode(shipmentTable),
        sttClientSttId: Number(shipmentTable.shipmentSttClientId),
        sttVendorSttId: 0,
        sttIsCod: shipmentTable.shipmentIsDfod
          ? true
          : shipmentTable.shipmentIsCod,
        sttIsWoodpacking: shipmentTable.shipmentIsWoodpacking,
        sttPieces: this.mappingSttPieces(shipmentTable),
        sttPiecePerPack: Number(shipmentTable.piecePerPack || 0),
        sttNextCommodity: shipmentTable.nextCommodity || "",
        sttCodAmount:
          shipmentTable.shipmentIsDfod ||
          shipmentTable.codDfodValue === "non-cod"
            ? 0
            : Number(shipmentTable.codAmount.toString().replace(/[.]/g, "")),
        postalCodeDestination: shipmentTable.postalCodeDestination,
        sttIsDfod: shipmentTable.shipmentIsDfod,
        codHandling: this.shipmentC1Cod(shipmentTable)
          ? shipmentTable.shipmentCodHandling
          : "",
        sttIsSaveSender: false,
        sttIsSaveReceiver: false,
        sttIsDo: shipmentTable.isDO,
        isMixpack: false,
        sttCodFee: Number(shipmentTable.codFee.toString().replace(/[.]/g, "")),
        discountFavoritePercentage: this.isShipmentAPAS(
          shipmentTable.shipmentAlgoId
        )
          ? shipmentTable.discountFavoritePercentage
          : 0,
        sttAttachFiles: shipmentTable.STT?.sttAttachFiles,
        sttRecipientEmail: shipmentTable.STT?.sttRecipientEmail || "",
        sttKtpImage: shipmentTable.STT?.sttKtpImage || "",
        sttTaxImage: shipmentTable.STT?.sttTaxImage || "",
        sttInterTaxNumber: shipmentTable.STT?.sttInterTaxNumber || "",
        sttIdentityNumber: shipmentTable.STT?.sttIdentityNumber || "",
        sttCipl: shipmentTable.STT?.sttcipl
      }),
      shipmentPackageId: shipmentTable.shipmentPacketId,
      otherShipperTicketCode: shipmentTable.dataRaw?.other_shipper_ticket_code,
      sttWeightAttachFiles: this.storageImages.filter((key) => key !== "")
    });
  }

  async addShipmentBooking(
    shipmentTable: ShipmentIdTable | ShipmentId,
    payload: AddShipmentBookingV2,
    fromModal = false,
    isAddAddress = false
  ) {
    if (MainAppController.loadingModal) return;
    MainAppController.showLoading();
    try {
      const resp = await ShipmentBookingController.addShipmentBookingV2(
        payload
      );
      if (fromModal) {
        this.shipmentList = this.shipmentList.filter(
          (_item, index) => index !== this.selectedIndex
        );
        this.selectedIndex = 0;
        this.isBookingShipment = this.shipmentList.length > 0;
      }
      this.updateShipmentTableData(resp, shipmentTable, isAddAddress);
      // for validation show/hide amount on success modal
      this.successShipmentId =
        shipmentTable.shipmentId || shipmentTable.shipmentAlgoId;
      this.modalSuccessTotalPieces =
        payload.stt?.sttPieces?.length ||
        shipmentTable.shipmentGoodDetail?.length ||
        1;
      this.handleModalSuccess(resp, shipmentTable.shipmentAlgoId);
      if (!fromModal && this.isBookingMarketplaceV4) {
        this.startSequentialBookingSession();
      }
      return resp;
    } catch (err) {
      const errorType = err.response
        ? err.response.data.message.error_type ||
          err.response.data.message?.[this.locale]
        : "";
      this.modalFailedBookingData = {
        error: !err.response
          ? ""
          : err.response.status > 500
          ? "SYSTEM"
          : errorType,
        balance: err.response?.data?.message.balance || 0,
        price: err.response?.data?.message.price || 0
      };
      this.onReloadBooking = () => {
        this.addShipmentBooking(
          shipmentTable,
          payload,
          fromModal,
          isAddAddress
        );
        this.onCloseFailedBooking();
      };
      this.isShowModalFailedBooking = true;
      if (err.response?.status < 500)
        this.updateShipmentTableErrorData(err, shipmentTable);
    } finally {
      MainAppController.closeLoading();
    }
  }

  async addBookingCorporate(
    shipmentTable: ShipmentIdTable | ShipmentId,
    payload: AddShipmentBookingV2,
    fromModal = false
  ) {
    if (MainAppController.loadingModal) return;
    MainAppController.showLoading();
    try {
      const resp = await this.bookingShipmentCorporate(payload);
      if (!resp) return;
      if (fromModal) {
        this.shipmentList = this.shipmentList.filter(
          (_item, index) => index !== this.selectedIndex
        );
        this.selectedIndex = 0;
        this.isBookingShipment = this.shipmentList.length > 0;
      }
      this.updateShipmentTableData(resp, shipmentTable, false);
      this.modalSuccessTotalPieces =
        payload.stt?.sttPieces?.length ||
        shipmentTable.shipmentGoodDetail?.length ||
        1;
      this.handleModalSuccess(resp, shipmentTable.shipmentAlgoId);
      if (!fromModal && this.isBookingMarketplaceV4) {
        this.startSequentialBookingSession();
      }
      return resp;
    } catch (err) {
      const errorType = err.response
        ? err.response.data.message.error_type ||
          err.response.data.message?.[this.locale]
        : "";
      this.modalFailedBookingData = {
        error: !err.response
          ? ""
          : err.response.status > 500
          ? "SYSTEM"
          : errorType,
        balance: err.response?.data?.message.balance || 0,
        price: err.response?.data?.message.price || 0
      };
      this.onReloadBooking = () => {
        this.addBookingCorporate(shipmentTable, payload, fromModal);
        this.onCloseFailedBooking();
      };
      this.isShowModalFailedBooking = true;
      if (err.response?.status < 500)
        this.updateShipmentTableErrorData(err, shipmentTable);
    } finally {
      MainAppController.closeLoading();
    }
  }

  successShipmentId = "";

  get hideTariffSuccessBooking() {
    return !isCustomerApps(this.modalSuccessBookingData.shipmentId);
  }

  handleModalSuccess(resp: ResponsePayload, shipmentId = "") {
    this.isShowModalSuccessBooking = true;
    const data = resp?.data || {};

    this.modalSuccessBookingData = new SuccessBooking({
      codAmount: data.cod_amount,
      codFee: data.cod_fee,
      destinationCityName: data.destination_city_name,
      destinationDistrictName: data.destination_district_name,
      estimateSla: data.estimate_sla,
      estimationDate: data.estimation_date,
      isCod: data.is_cod,
      isDfod: data.is_dfod,
      listDiscount: data.list_discount || [],
      recipientName: data.recipient_name,
      stt: (data.stt || []).map(
        (stt: any) =>
          new STT({
            sttRecipientName: stt.stt_recipient_name,
            sttNo: stt.stt_no,
            sttId: stt.stt_id,
            chargeableWeight: stt.chargeable_weight,
            sttDestinationDistrictName: data.destination_district_name,
            productType: stt.product_type,
            totalAfterDiscount: stt.total_after_discount,
            totalBeforeDiscount: stt.total_before_discount,
            codAmount: stt.cod_amount ?? data.cod_amount ?? 0,
            listDiscount: stt.list_discount || data.list_discount || []
          })
      ),
      shipmentId
    });
  }

  updateShipmentTableData(
    resp: ResponsePayload,
    shipmentIdTable: ShipmentIdTable | ShipmentId,
    isAddAddress: boolean
  ) {
    const stt = new ShipmentIdSTT({
      shipmentAlgoId: shipmentIdTable.shipmentAlgoId,
      sttId: resp.sttId,
      sttNo: resp.sttNumber,
      sttProductType: shipmentIdTable.shipmentProduct,
      sttTotalAmount: resp.totalAfterDiscount,
      sttPieces: this.mappingSttPieces(shipmentIdTable),
      sttChargeableWeight: resp.chargeableWeight,
      sttIsCod: resp.data.is_cod,
      sttIsDfod: resp.data.is_dfod
    });
    if (isAddAddress) {
      const targetGroup = this.shipmentIdData.find(
        (item) => item.shipmentId === shipmentIdTable.shipmentAlgoId
      );
      if (!targetGroup) return;
      targetGroup.data.push(
        new ShipmentIdTable({
          ...shipmentIdTable,
          id: new Date().getTime(),
          STT: stt,
          isInstantBooking: !!stt,
          error: null
        })
      );
    } else {
      this.shipmentIdData = this.shipmentIdData.map(
        (item: ShipmentDataProps) => {
          const updatedData = item.data.map((dataItem) => {
            if (this.isSameShipmentRow(dataItem, shipmentIdTable)) {
              return {
                ...dataItem,
                STT: stt,
                isInstantBooking: !!stt,
                error: null
              };
            }
            return dataItem;
          });
          return {
            ...item,
            data: updatedData
          };
        }
      );

      const aggregateIndex = this.aggregateState.shipmentRows.findIndex(
        (item) => this.isSameShipmentRow(item, shipmentIdTable)
      );
      if (aggregateIndex !== -1) {
        const row = this.aggregateState.shipmentRows[aggregateIndex];
        this.aggregateState.shipmentRows.splice(aggregateIndex, 1, {
          ...row,
          STT: stt,
          isInstantBooking: true,
          error: null,
          bookingStatus: "berhasil_dibooking"
        });
      }
    }
  }

  updateShipmentTableErrorData(
    error: any,
    shipmentIdTable: ShipmentIdTable | ShipmentId
  ) {
    const errorMessage =
      error.response.data.message.short_id ||
      error.response.data.message?.[this.locale];
    this.shipmentIdData = this.shipmentIdData.map((item: ShipmentDataProps) => {
      const updatedData = item.data.map((dataItem) => {
        if (this.isSameShipmentRow(dataItem, shipmentIdTable)) {
          return {
            ...dataItem,
            error: errorMessage,
            bookingStatus: "gagal_dibooking" as const
          };
        }

        return dataItem;
      });
      return {
        ...item,
        data: updatedData
      };
    });

    const aggregateIndex = this.aggregateState.shipmentRows.findIndex((item) =>
      this.isSameShipmentRow(item, shipmentIdTable)
    );
    if (aggregateIndex !== -1) {
      const row = this.aggregateState.shipmentRows[aggregateIndex];
      this.aggregateState.shipmentRows.splice(aggregateIndex, 1, {
        ...row,
        error: errorMessage,
        bookingStatus: "gagal_dibooking"
      });
    }
  }

  onCloseSuccessBooking() {
    this.isShowModalSuccessBooking = false;
    this.successShipmentId = "";

    if (!this.stateIsNewBooking) {
      if (this.isBookingShipment) {
        const refs: any = this.$refs;
        refs["modal-shipment"]?.onSuccessProcees();
      }
      return;
    }

    if (this.isSequentialBookingActive && !this.isBookingShipment) {
      this.startSequentialModal();
    }
  }

  startSequentialBookingSession(): void {
    this.isSequentialBookingActive = true;
    this.skippedBookingShipmentIds = new Set();
  }

  buildSequentialShipmentList(): ShipmentIdTable[] {
    return this.allShipmentGroups
      .flatMap((group) => group.data)
      .filter(
        (row) =>
          !row.STT?.sttNo &&
          !row.error &&
          !this.skippedBookingShipmentIds.has(String(row.id))
      );
  }

  startSequentialModal(): void {
    const queue = this.buildSequentialShipmentList();
    if (!queue.length) {
      this.isSequentialBookingActive = false;
      return;
    }
    this.shipmentList = queue;
    this.selectedIndex = 0;
    this.isAddAddress = false;
    this.isBookingShipment = true;
  }

  onSkipShipment(shipment: ShipmentIdTable | null | undefined): void {
    if (!shipment) return;
    this.skippedBookingShipmentIds.add(String(shipment.id));
    this.shipmentList = this.shipmentList.filter(
      (item) => item.id !== shipment.id
    );
    if (this.shipmentList.length) {
      this.selectedIndex = 0;
      this.isBookingShipment = true;
    } else {
      this.selectedIndex = 0;
      this.isSequentialBookingActive = false;
      this.isBookingShipment = false;
    }
    if (this.isSequentialBookingActive && !this.isBookingShipment) {
      this.startSequentialModal();
    }
  }

  onCloseFailedBooking() {
    this.isShowModalFailedBooking = false;

    if (this.isBookingMarketplaceV4 && this.isSequentialBookingActive) {
      this.isSequentialBookingActive = false;
      this.skippedBookingShipmentIds = new Set();
    }
  }

  async printPDFOnSuccessBooking(sttId: any, sttNo: any) {
    const print = await this.generatePrintData(sttId, sttNo);
    if (print) {
      await this.loadToPdf(0, true, true);
    }
  }

  async loadToPdf(
    type: number,
    withInvoice = false,
    autoPrint = false,
    isBookInstan = false
  ) {
    const validateInter =
      this.printData().sttProductType.toLowerCase() === "interpack" ||
      this.printData().sttProductType.toLowerCase() === "interpackmaxi";
    await this.generateReceipt(
      this.printData(),
      type,
      autoPrint,
      isBookInstan,
      validateInter
    );
    if (validateInter && withInvoice) {
      this.printInterpack(this.printData());
    }
  }

  async generateReceipt(
    printData: PrintDataEntitas,
    type = 0,
    autoPrint = false,
    isBookInstan = false,
    isInterpack = false
  ) {
    /* barcode */
    const barcode = document.createElement("img");
    JsBarcode(barcode, printData.sttNo, {
      textAlign: "left",
      displayValue: false,
      fontSize: 16
    });

    /* vendor ref code */
    let vendorRefCode: any = "";
    if (printData.sttVendorRefferenceNo) {
      vendorRefCode = document.createElement("img");
      JsBarcode(vendorRefCode, printData.sttVendorRefferenceNo, {
        textAlign: "left",
        displayValue: false,
        fontSize: 16
      });
    }
    const lang = isInterpack
      ? "en"
      : AccountController.accountData.accountIsForeign
      ? "en"
      : "id";

    if (type === 0) {
      await generateThermalPDFV2(
        "shipment",
        AccountController.accountData.account_type,
        printData,
        barcode.src,
        vendorRefCode?.src,
        printData.sttElexysNo || printData.sttNo,
        printData.sttVendorRefferenceNo,
        logoBlack,
        this.printData().sttShipmentId,
        true,
        lang,
        autoPrint,
        isBookInstan
      );
    } else {
      await generatePDFV2(
        "shipment",
        AccountController.accountData.account_type,
        printData,
        barcode.src,
        vendorRefCode?.src,
        printData.sttElexysNo || printData.sttNo,
        printData.sttVendorRefferenceNo,
        logoBlack,
        this.printData().sttShipmentId,
        true,
        lang
      );
    }
  }

  async printThermal(sttId: any, sttNo: any) {
    const print = await this.generatePrintData(sttId, sttNo);

    if (print) {
      const accountType = AccountController.accountData.account_type;
      const payload = payloadOfThermalData(
        this.printData(),
        AccountController.accountData.account_type
      ).map((item: ThermalReceiptData) => ({
        ...item,
        isHubToHub: this.printData().isHubToHub,
        sttBookedForName: this.printData().sttBookedForName,
        otherShipperTicketCode: this.printData().otherShipperTicketCode,
        sttIsCodRetail:
          this.bookingTypePayload(this.printData()) === "manual" &&
          (accountType === "partner" || accountType === "internal") &&
          item.sttIsCod
      }));
      downloadFilePrn(payload, this.$i18n.locale);
      if (
        this.printData().sttProductType.toLowerCase() === "interpack" ||
        this.printData().sttProductType.toLowerCase() === "interpackmaxi"
      ) {
        this.printInterpack(this.printData());
      }
    }
  }

  async fetchReceipt(
    target: ReceiptPrintTarget
  ): Promise<PrintDataEntitas | false> {
    const result = await BookingController.getPrintDataBySttBatch(
      new PrintDetailRequest({
        sttNo: target.sttNo,
        id: target.sttId,
        accountType: target.accountType
      })
    );

    if (typeof result === "boolean") return false;

    return result;
  }

  async generatePrintData(
    sttId: number,
    sttNo: string
  ): Promise<PrintDataEntitas | false> {
    return this.fetchReceipt({
      sttId,
      sttNo,
      accountType: this.printAccountType
    });
  }

  printData(): PrintDataEntitas {
    return BookingController.generatePrintData;
  }

  bookingTypePayload(printData: PrintDataEntitas) {
    let type = "client";
    if (printData.sttReverseJourneyShipmentId.match(/^ARA|^ARB|^AP|^AS/)) {
      type = "manual";
    }
    if (printData.sttShipmentId) {
      type = "shipment";
    }

    if (!printData.sttShipmentId && printData.sttClientId === 0) {
      type = "manual";
    }
    return type;
  }

  async printInterpack(
    headerData: PrintDataEntitas,
    pageSize: "a4" | "a6" = "a4"
  ) {
    MainAppController.showLoading();
    try {
      const logo = await import("@/app/ui/assets/images/logo-lion-parcel.png");
      const locales = AccountController.accountData.account_type_detail.countryCode?.toLowerCase();
      generateCommercialInvoiceV2(
        headerData,
        logo.default,
        locales === "my" ? "my" : undefined,
        pageSize
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  // bulk print
  resiListData: Array<PrintDataEntitas> = [];
  failedReceiptTargets: ReceiptPrintTarget[] = [];

  resetResiListData() {
    this.resiListData = [];
    this.failedReceiptTargets = [];
  }

  async fetchReceiptTargets(
    targets: ReceiptPrintTarget[]
  ): Promise<PrintDataEntitas[]> {
    const results = await Promise.allSettled(
      targets.map((target) => this.fetchReceipt(target))
    );

    return results.reduce<PrintDataEntitas[]>((receipts, result, index) => {
      if (result.status === "fulfilled" && result.value) {
        receipts.push(result.value);
      } else {
        this.failedReceiptTargets.push(targets[index]);
      }

      return receipts;
    }, []);
  }

  async generateResiListDataBatch(shipmentGroups: ShipmentDataProps[]) {
    MainAppController.showLoading();
    try {
      const batchSize = 10;

      const orderMap = new Map<string, number>(
        shipmentGroups.map(
          (item, index) => [item.shipmentId, index] as [string, number]
        )
      );
      const finalResults: PrintDataEntitas[][] = new Array(
        shipmentGroups.length
      );
      const shipmentBatches = this.chunk(shipmentGroups, batchSize);

      for (const batch of shipmentBatches) {
        await Promise.all(
          batch.map(async (item) => {
            const printTargets = this.mapReceiptPrintTargets(item.data);
            const resultsPerShipment = await this.fetchReceiptTargets(
              printTargets
            );

            const index = orderMap.get(item.shipmentId);
            if (index !== undefined) {
              finalResults[index] = resultsPerShipment;
            }
          })
        );
      }
      this.resiListData = finalResults.filter(Boolean).flat();
    } catch (e) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(e, "Penarikan Data Gagal", () => {
          MainAppController.closeErrorMessage();
          this.generateResiListDataBatch(shipmentGroups);
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  // convert table data into chunks
  chunk<T>(data: T[], batchSize: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < data.length; i += batchSize) {
      chunks.push(data.slice(i, i + batchSize));
    }
    return chunks;
  }

  printThermalListStt() {
    const payloadPushed: any[] = [];
    const accountType = AccountController.accountData.account_type;
    this.resiListData.forEach((item, index) => {
      if (item) {
        payloadPushed.push(
          payloadOfThermalData(item, accountType).map((e) => ({
            ...e,
            isHubToHub: item.isHubToHub,
            sttBookedForName: item.sttBookedForName,
            otherShipperTicketCode: item.otherShipperTicketCode,
            sttIsCodRetail:
              !item.sttShipmentId &&
              !item.sttClientId &&
              (accountType === "partner" || accountType === "internal") &&
              e.sttIsCod
          }))
        );

        if (index === this.resiListData.length - 1) {
          new Promise((resolve) => {
            MainAppController.showLoading();
            setTimeout(resolve.bind(null, null), 1);
          }).then(() => {
            const payloadResult = flatten(payloadPushed);
            downloadFilePrn(payloadResult, "id", true);
            MainAppController.closeLoading();
          });
        }
      }
    });
  }

  async printDocListStt(type: string) {
    const listSttPieces: any = [];

    this.resiListData.forEach((item, index) => {
      if (item) {
        const barcode = document.createElement("img");
        const vendorBarcode = document.createElement("img");
        JsBarcode(barcode, item.sttNo, {
          textAlign: "left",
          displayValue: false,
          fontSize: 16
        });
        if (item.sttVendorRefferenceNo) {
          // vendor ref code
          JsBarcode(vendorBarcode, item.sttVendorRefferenceNo, {
            textAlign: "left",
            displayValue: false,
            fontSize: 16
          });
        }

        item.sttPieces.forEach((e) => {
          listSttPieces.push({
            ...e,
            ...item,
            barcode: barcode.src,
            vendorRefCode: vendorBarcode.src
          });
        });

        barcode.remove();
        vendorBarcode.remove();
      }
    });

    if (listSttPieces.length) {
      new Promise(function(resolve) {
        MainAppController.showLoading();
        setTimeout(resolve.bind(null, null), 1);
      }).then(() => {
        const accountType = AccountController.accountData.account_type;
        if (type === "a6") {
          generateThermalPDF(accountType, listSttPieces, []);
        } else {
          generatePDF(accountType, listSttPieces, []);
        }

        MainAppController.closeLoading();
      });
    }
  }

  // check data

  checkBookingData(shipment: ShipmentIdTable | ShipmentId, isTKP: boolean) {
    return (
      (isTKP ? !!shipment.STT : !!shipment.STT?.sttId) ||
      this.checkEligible(shipment) ||
      this.checkShipmentGoodDetail(shipment, isTKP)
    );
  }

  checkCommodity(shipment: ShipmentIdTable | ShipmentId) {
    return !shipment.shipmentCommodityCode;
  }

  get bulkShipment(): string {
    return String(this.$route.query.bulk || "");
  }

  async autoScanShipment() {
    if (!this.bulkShipment) return;

    const shipmentIds = this.bulkShipment.split(",");
    await this.onScanShipment(shipmentIds, () => {});
  }

  get instantBookingDirectFlowEnabled() {
    return FlagsPermissionBookingV3.instant_booking_v2.isEnabled();
  }

  get stateIsNewBooking() {
    return this.bookingState === "v4";
  }

  isCrossCountryCod = false;
  prefixCurrency = "";
}
export default CreateBookingShipment;
